import type { Tenant } from '../../../Entities/App/Tenants.entity';
import type {
  FilterKey,
  FilterParams,
  QueryParams,
  UrlParams,
} from '../../../Entities/Search/QueryParams.entity';
import { stringifyParams } from './queryParamUtils';

export const mapQueryParams = (params: UrlParams, tenant?: Tenant) => {
  const filterParams = {} as FilterParams;
  for (const key in params) {
    const newKey = key.replace('[]', '') as FilterKey;

    filterParams[newKey] =
      tenant === 'rac' && params[key] === 'relevance-desc'
        ? 'rac-relevance-desc'
        : (params[key] as any);
  }

  const isDealerApp = tenant === 'dealerFlow';
  const defaultPage = isDealerApp ? 1 : 0;
  const parsedPage = filterParams?.page ? parseInt(filterParams.page, 10) : 0;

  if (tenant === 'rac') filterParams['apply-exclusions'] = 'rac';

  if (filterParams['vat-status'])
    filterParams['vat-status'] = filterParams['vat-status'].toUpperCase();

  let mappedParams: QueryParams | object = {};
  let pageValue: number;

  if (parsedPage > 0) {
    pageValue = isDealerApp ? parsedPage : parsedPage - 1;
  } else {
    pageValue = defaultPage;
  }

  mappedParams = {
    ...filterParams,
    page: pageValue,
  };
  const queryString = stringifyParams(mappedParams);

  return { mappedParams: mappedParams as FilterParams, queryString };
};
